import $ from "jquery";
// Reference https://github.com/tensorflow/tfjs-models/tree/master/pose-detection/src/movenet
import * as poseDetection from '@tensorflow-models/pose-detection';
import * as tf from '@tensorflow/tfjs-core';
// Register one of the TF.js backends.
import '@tensorflow/tfjs-backend-webgl';
// import '@tensorflow/tfjs-backend-wasm';

import { extendLine } from "./js/utils/cursor";
import MainGame from "./js/game/main";
import Cursor from "./js/anim/cursor";
import RenderableSegmentationMask from "./js/anim/segmentationMask";

//Global Vars & Functions
let currentLang = window.localStorage.getItem('lang') == 'en' ? 'en' : 'jp';
let mirror = true;
let showFPS = window.localStorage.getItem('showFPS') !== undefined ? Boolean(window.localStorage.getItem('showFPS') == 'true') : true;
let activePageEventLoop = null;
let activeCamStream = null;
let selectedWebcam = null;
let predictionActive = false;
let mediapipeInitialised = false;
let newPoseModel, newPoseModelMode;

/** @type {import("./js/game/main")} */
let Game;

function closeNotifi(elm) {
  console.dir(elm);
  $(elm).parent().parent().animate({ opacity: 0, height: 0, margin: 0, padding: 0 }, 1000, () => {
    $(elm).parent().parent().remove();
  });
}
function notifi(status, title, text) {
  let notifi = $("<article>", { class: "notifi message " + status });
  let header = $("<div>", { class: "message-header" });
  header.text(title);
  header.append($("<button>", { class: "delete", click: (e) => { closeNotifi(e.target) } }));
  let body = $("<div>", { class: "message-body" });
  body.html(text);
  notifi.append(header, body);
  $('#notifications').append(notifi);
}
function closeModalAuto(modalId) {
  $(modalId + " .modal-background").animate({ opacity: 0 }, 1000)
  $(modalId + " .modal-card").animate({ right: "100%" }, 1000, () => {
    $(modalId).removeClass('is-active');
    $(modalId + " .modal-background").css("opacity", "1")
    $(modalId + " .modal-card").css("right", "0%")
  });
}
function closeModal(elm, stopLoad, stopStream) {
  let modal = elm.parentElement.parentElement.parentElement
  $(modal).addClass("is-closing");
  $(modal).find(".modal-background").animate({ opacity: 0 }, 1000, () => {
    $(modal).removeClass('is-active');
    $(modal).removeClass("is-closing");
    $(modal).find(".modal-background").css("opacity", "1")
  });
  if (stopLoad) {
    $("#startBtn").removeClass('is-loading');
  }
  if (stopStream) {
    stopCamStream()
  }
}
function updateLang(){
  $(`[data-${currentLang}]`).each((_, elm) => {
    $(elm).text($(elm).attr(`data-${currentLang}`))
  })
  if (Game){
    Game.lang = currentLang;
  }
  window.localStorage.setItem('lang', currentLang);
  $(".lang-btn").removeClass("is-active");
  $(".lang-btn-2").removeClass("is-active");
  $(`#lang-${currentLang}-btn`).addClass("is-active");
  $(`#lang-${currentLang}-btn-2`).addClass("is-active");
  document.documentElement.setAttribute('lang', ['en', 'jp'].includes(currentLang) ? currentLang : 'jp');
}
function stopCamStream() {
  if (activeCamStream) {
    activeCamStream.getTracks().forEach(function (track) {
      track.stop();
    });
  }
}


//MediaPose Utilities
let vision;
/** @type {import("@tensorflow-models/pose-detection").PoseDetector} */
let poseLandmarker;
let poseModel = window.localStorage.getItem('poseModel') || 'blazepose';
let poseModelMode = window.localStorage.getItem('poseModelMode') || 'full';
if (!((poseModel === 'blazepose' && ['lite', 'full', 'heavy'].includes(poseModelMode)) || (poseModel === 'movenet' && ['thunder', 'lightning'].includes(poseModelMode)))){
  poseModel = 'blazepose';
  poseModelMode = 'full';
  window.localStorage.setItem('poseModel', poseModel);
  window.localStorage.setItem('poseModelMode', poseModelMode);
}
async function initUtils() {
  try{
    await Promise.all([
      new Promise(async (resolve, reject) => {
        try {
          try{
            await tf.setBackend('webgpu');
            if (poseModel === 'movenet'){
              poseLandmarker = await poseDetection.createDetector(poseDetection.SupportedModels.MoveNet, {
                modelType: poseModelMode == 'thunder' ? poseDetection.movenet.modelType.SINGLEPOSE_THUNDER : poseDetection.movenet.modelType.SINGLEPOSE_LIGHTNING,
                enableSmoothing: true,
              });
            }
            else if (poseModel === 'blazepose'){
              poseLandmarker = await poseDetection.createDetector(poseDetection.SupportedModels.BlazePose, {
                runtime: 'mediapipe',
                solutionPath: './mediapipeAssets',
                modelType: poseModelMode,
                enableSmoothing: true,
                enableSegmentation: true,
                smoothSegmentation: true,
                
              });
            }
          }
          catch(e){
            console.warn(e);
            console.log("WebGPU Initialiasation Failed, falling back to WebGL...")
            await tf.setBackend('webgl');
            if (poseModel === 'movenet'){
              poseLandmarker = await poseDetection.createDetector(poseDetection.SupportedModels.MoveNet, {
                modelType: poseModelMode == 'thunder' ? poseDetection.movenet.modelType.SINGLEPOSE_THUNDER : poseDetection.movenet.modelType.SINGLEPOSE_LIGHTNING,
                enableSmoothing: true,
              });
            }
            else if (poseModel === 'blazepose'){
              poseLandmarker = await poseDetection.createDetector(poseDetection.SupportedModels.BlazePose, {
                runtime: 'mediapipe',
                solutionPath: './mediapipeAssets',
                modelType: poseModelMode,
                enableSmoothing: true,
                enableSegmentation: true,
                smoothSegmentation: true,
                
              });
            }
          }
          resolve()
        }
        catch (e) {
          reject(e)
        }
      }),
      new Promise(
        async (resolve, reject) => {
          try {
            // FONT MAY RANDOMLY FAIL TO LOAD DURING TESTING, SEE https://stackoverflow.com/a/58689370/18573662
            await fetch('./assets/fonts/Yusei Magic/YuseiMagic-Regular.ttf');
            let attemptCount = 0;
            let fontLoaded = false;
            while (!fontLoaded && attemptCount <= 5){
              try{
                const font = await (new FontFace('Yusei Magic', 'url(\'./assets/fonts/Yusei Magic/YuseiMagic-Regular.ttf\')', { style: 'normal', weight: 400 })).load()
                document.fonts.add(font);
                fontLoaded = true;
              }
              catch(e){
                if (attemptCount >= 5){
                  throw e
                }
                else{
                  console.error(e);
                  console.warn("Font failed to load, retrying...");
                  attemptCount++;
                  continue
                }
              }
            }
            console.info("GAME FONT LOADED");
            document.fonts.ready.then(() => resolve()).catch((e) => {reject(e)})
            
          }
          catch (e) {
            reject(e)
          }
        }),
      new Promise(
        async (resolve, reject) => {
          try {
            canvasElement = document.getElementById("canvas");
            canvasCtx = canvasElement.getContext("2d");
            Game = new MainGame(canvasCtx, window.innerWidth, window.innerHeight, 0, 0, 'webcam', currentLang);// Initialise game first, later then resize when webcam is ready.
            await Game.load();
            console.info("GAME ICONS & IMAGES LOADED")
            resolve()
          }
          catch (e) {
            reject(e)
          }
        })]);
    mediapipeInitialised = true;
    console.info("MEDIAPIPE UTILS READY")
  }
  catch (e){
    notifi('is-danger', "Error", `ゲームの初期化に失敗しました。ページを再読み込みしてみてください。<br>The game has failed to initialise. Please try to refresh the page.<br>${e}`)
    console.error(e);
  }
}



//Page 1
function getDevices() {
  return navigator.mediaDevices.enumerateDevices().then((devices) => {
    $('select#videoSource').empty();
    let deviceCount = 0;
    for (var i = 0; i < devices.length; i++) {
      let device = devices[i];
      if (device.kind === 'videoinput') {
        deviceCount++;
        let opt = $("<option>", { value: device.deviceId, text: device.label || 'Camera ' + deviceCount });
        $('select#videoSource').append(opt);
      }
    };
    if (deviceCount >= 1) {
      return webcamStart();
    }
  });
}

function webcamStart() {
  let useWebcam = $('select#videoSource').val();
  $("#webcamConfirmBtn").addClass("is-loading");
  stopCamStream()
  return navigator.mediaDevices.getUserMedia({ audio: false, video: { deviceId: useWebcam } }).then((stream) => {
    const videoTracks = stream.getVideoTracks();
    selectedWebcam = videoTracks[0].getSettings().deviceId;
    // if (useWebcam != selectedWebcam){
    //   $('select#videoSource').val(selectedWebcam)
    //   notifi("is-danger","Error","The selected webcam is not compatible and cannot be used.")
    // }
    //console.log("Got stream with constraints:", constraints);
    console.log(`Using video device: ${videoTracks[0].label}`);
    activeCamStream = stream;
    stream.onremovetrack = () => {
      console.log("Stream ended");
    };
    document.getElementById('webcamIn').srcObject = stream;
    document.getElementById('webcamIn').play();
    $("#webcamConfirmBtn").attr("disabled", false);
  }).catch((error) => {
    $("#webcamConfirmBtn").attr("disabled", true);
    if (error.name === "NotAllowedError") {
      //Should not happen
      alert(
        "You need to grant this page permission to access your webcam.",
      );
    } else {
      console.error(`getUserMedia error: ${error.name}`, error);
    }
  }).finally(() => {
    $("#webcamConfirmBtn").removeClass("is-loading");
  });
}
function webcamPermitRequest(elm) {
  $(elm).addClass('is-loading')
  navigator.mediaDevices.getUserMedia({ audio: false, video: true }).then((stream) => {
    stream.getTracks().forEach(function (track) {
      track.stop();
    });
    return getDevices().then(() => {
      $("#webcamSelectModal").addClass('is-active')
    });
  }).catch((error) => {
    if (error.name === "NotAllowedError") {
      $("#webcamBlockedModal").addClass('is-active')
    } else {
      console.error(`getUserMedia error: ${error.name}`, error);
    }
  }).finally(() => {
    closeModalAuto("#webcamPermitReqModal");
    $(elm).removeClass('is-loading')
  });
}
function setUp(elm) {
  $(elm).addClass('is-loading')
  // BUG: Firefox no support navigator.permissions.query with 'camera'
  navigator.permissions.query({ name: "camera" }).then(res => {
    if (res.state == "granted") {
      getDevices().then(() => {
        $("#webcamSelectModal").addClass('is-active')
      });
    }
    else if (res.state === "prompt") {
      $("#webcamPermitReqModal").addClass('is-active')
    }
    else {
      $("#webcamBlockedModal").addClass('is-active')
    }
  }).catch((err) => {
    if (err.message == "Permissions.query: 'camera' (value of 'name' member of PermissionDescriptor) is not a valid value for enumeration PermissionName.") {
      $("#webcamPermitReqModal").addClass('is-active');
    }
  }).finally(() => {
    closeModalAuto('#selectGameModeModal');
    $(elm).removeClass('is-loading');
  })
}
function gameInit(elm) {
  $(elm).addClass('is-loading')
  if (!mediapipeInitialised) {
    $('#takingSomeTimeModal').addClass('is-active');
    return setTimeout(() => { gameInit(elm) }, 1000);
  }
  return page2Init().then(() => {
    closeModal(elm.parentElement);
    closeModal(document.getElementById('takingSomeTimeModalTitle'));
    $("#pg2").removeClass("hidden")
    $("#pg1").animate({ right: "100%" }, 1000, () => {
      $("#pg1").addClass("hidden").css("right", "0%");
      $(elm).removeClass('is-loading')
    });
  });

}
function page1Init() {
  // $("#pg1 #startBtn").on('click', (event) => { setUp(event.target) })
  $("#webcamSelectModal button.delete").on('click', (event) => { closeModal(event.target, true, true) });
  $("#webcamSelectModal .select").on('change', webcamStart);
  $("#webcamSelectModal #webcamConfirmBtn").on('click', (event) => { gameInit(event.target) });
  $("#webcamPermitReqModal button.delete").on('click', (event) => { closeModal(event.target, true) });
  $("#webcamPermitReqModal #webcamReqBtn").on('click', (event) => { webcamPermitRequest(event.target) });
  $("#webcamBlockedModal button.delete").on('click', (event) => { closeModal(event.target, true) });
  $("#settingsModal button.delete").on('click', (event) => { closeModal(event.target, true) });
  $("#settingsBtn").on('click', (event) => { $('#settingsModal').addClass('is-active') });
  // $('#gameLangSelect').on('change', (event) => {
  //   currentLang = event.currentTarget.value;
  //   updateLang();
  // });

  $(".lang-btn, .lang-btn-2").on('click', (event) => {
    currentLang = $(event.currentTarget).attr('data-lang');
    updateLang();
  })
  $('.gameModeOption').on('click', (event) => {
    $('.gameModeOption').each((_, elm) => elm.classList.remove('selected'));
    event.currentTarget.classList.add('selected');
    $('#gameModeBtn').attr('disabled', false);
  })
  $("#pg1 #startBtn").on('click', (event) => { $('#selectGameModeModal').addClass('is-active') })
  $("#selectGameModeModal button.delete").on('click', (event) => { closeModal(event.target) });
  $("#selectGameModeModal #gameModeBtn").on('click', (event) => {
    if ($('#selectGameModeModal #webcamGameOption').hasClass('selected')){
      setUp(event.target);
    }
    else{
      event.target.classList.add('is-loading');
      window.location.href = `./cursor.html?lang=${currentLang}`;
    }
  });
  $("#useTouchCursorModeLink").on("click", ()=>{
    window.location.href = `./cursor.html?lang=${currentLang}`;
  });
  $('#FPSCheckbox').on("change", () => {
    showFPS = $('#FPSCheckbox').prop('checked');
    localStorage.setItem('showFPS', showFPS)
  })
  $('#poseModelSelect').on("change", () => {
    [newPoseModel, newPoseModelMode] = $('#poseModelSelect').val().split('-');
    if (newPoseModel != poseModel || newPoseModelMode != poseModelMode){
      $('#modelChangeSaveBtn').attr('disabled', false);
    }
    else{
      $('#modelChangeSaveBtn').attr('disabled', true);
    }
  })
  $('#modelChangeSaveBtn').on('click', ()=>{
    if (newPoseModel != poseModel || newPoseModelMode != poseModelMode){
      $('#modelChangeSaveBtn').addClass('is-loading');
      window.localStorage.setItem('poseModel', newPoseModel);
      window.localStorage.setItem('poseModelMode', newPoseModelMode);
      window.location.reload();
    }
  })
}




//Page 2
let video;
let canvasElement;
/** @type {CanvasRenderingContext2D} */
let canvasCtx;
let videoScalling;
let prevTimeMs;
let prevRightCursor, prevRightCursorTime;
let prevLeftCursor, prevLeftCursorTime;
let cursorSize = 50;
let fullscreenToggled = false;
// let drawingUtils;
// let cursor_hover_elm = [null, null];

async function page2Init() {
  document.addEventListener("dblclick", () => {
    if (!fullscreenToggled && document.documentElement.requestFullscreen){
      document.documentElement.requestFullscreen({navigationUI: "hide"}).finally(()=>{
        fullscreenToggled = true
      })
    }
    else if (document.exitFullscreen){
      document.exitFullscreen().then(()=>{
          fullscreenToggled = false
      }).catch(()=> {
        if (document.documentElement.requestFullscreen){
          document.documentElement.requestFullscreen({navigationUI: "hide"}).finally(()=>{
            fullscreenToggled = true
          })
        }
      })
    }
  });
  document.documentElement.requestFullscreen({navigationUI: "hide"}).then(()=>{
    fullscreenToggled = true
  });
  document.getElementById("cursor-container").classList.add("is-active");
  video = document.getElementById("baseCameraIn");
  canvasElement = document.getElementById("canvas");
  canvasCtx = canvasElement.getContext("2d");
  // drawingUtils = new DrawingUtils(canvasCtx);
  //poseLandmarker.setOptions({canvas: canvasCtx});
  // console.dir(drawingUtils);
  document.getElementById('baseCameraIn').srcObject = activeCamStream;
  document.getElementById('baseCameraIn').play();
  await waitForVidInit();
  Game.setActiveScreen("intro")
  setVideoDimensions();
  window.onresize = setVideoDimensions;
  predictionActive = true;
  try {
    await predictWebcam();
  }
  catch (e) {
    notifi('is-danger', 'Error', `重大なエラーが発生しました。ページを再読み込みしてください！<br>A fatal error has occured. Please refresh the page!<br>${e}`)
    throw e;
  }
  activePageEventLoop = (landmarks) => {
    if (landmarks) {
      // //document.getElementById("dummy-cursor").style.setProperty("--cursor-x", (landmarks[15].y - landmarks[19].y)*10);
      // console.log((landmarks[15].y - landmarks[19].y)*100);
      // // if (landmarks[11].z - landmarks[19].z > 0.6){
      // // }
      // if ( landmarks[19].y < 1 && ((landmarks[15].y - landmarks[19].y)*100 < 8)){
      //   $("#left-hand-container").addClass('hover');
      // }
      // else{
      //   $("#left-hand-container").removeClass('hover');
      // }
    }
  };
  //setVideoDimensionsLoop();
}
async function waitForVidInit() {
  while (video.videoWidth == 0) {
    await new Promise(r => setTimeout(r, 100));
  }
  while (!mediapipeInitialised) {
    await new Promise(r => setTimeout(r, 100));
  }
}

function setVideoDimensions() {
  let scalingWidth = document.documentElement.clientWidth / video.videoWidth
  let scalingHeight = document.documentElement.clientHeight / video.videoHeight
  let scaling = Math.max(scalingWidth, scalingHeight)
  canvasElement.width = (video.videoWidth * scaling)
  canvasElement.style.width = (video.videoWidth * scaling) + "px";
  canvasElement.height = video.videoHeight * scaling;
  canvasElement.style.height = (video.videoHeight * scaling) + "px";
  video.style.width = (video.videoWidth * scaling) + "px";
  video.style.height = (video.videoHeight * scaling) + "px";
  videoScalling = scaling;
  Game.updateScreenRes(window.innerWidth, window.innerHeight, (canvas.width - window.innerWidth) / 2, (canvas.height - window.innerHeight) / 2);
}


function getCorodinatesForMovenet(landmarks, index, noFlip) {
  // Need to flip coordinates and resize
  if (noFlip){
    return [(landmarks[index].x * videoScalling), (landmarks[index].y * videoScalling)]
  }
  else{
    return [(canvasElement.width - landmarks[index].x * videoScalling), (landmarks[index].y * videoScalling)]
  }
}

function getCorodinatesForBlazepose(landmarks, wrist_index, pinky_index, index_finger_index){
  const averageX = new Array()
  const averageY = new Array()
  const hand_landmarks = [wrist_index, pinky_index, index_finger_index];
  for (let i = 0; i < hand_landmarks.length; i++){
    const landmark = landmarks[hand_landmarks[i]]
    if (landmark.score >= 0.15){
      averageX.push(landmark.x)
      averageY.push(landmark.y)
    }
  }
  if (averageX.length > 0 && averageY.length > 0){
    return [averageX.reduce((a,c) => (a+c), 0)/averageX.length*videoScalling, averageY.reduce((a,c) => (a+c), 0)/averageY.length*videoScalling]
  }

}


function smoothCursor(newCursor, animationStep, isLeft) {
  if (!animationStep) {
    return newCursor
  }
  if (isLeft) {
    // if (!prevLeftCursor || Math.sqrt((newCursor[1] - prevLeftCursor[1])**2 + (newCursor[0] - prevLeftCursor[0])**2) > 50){
    //   prevLeftCursor = newCursor;
    //   return newCursor;
    // }
    // else{
    //   return prevLeftCursor;
    // }
    const cursorDiffTiming = animationStep - (prevLeftCursorTime || animationStep)
    prevLeftCursorTime = animationStep;
    if (!prevLeftCursor || cursorDiffTiming <= 0) {
      return newCursor;
    }
    const diffY = newCursor[1] - prevLeftCursor[1];
    const diffX = newCursor[0] - prevLeftCursor[0];
    const cursorSpeed = Math.sqrt((diffY) ** 2 + (diffX) ** 2) / cursorDiffTiming;
    const cursorDiffAmount = Math.min(1, cursorSpeed / 500);
    return [newCursor[0] + diffX * cursorDiffAmount, newCursor[1] + diffY * cursorDiffAmount];

  }
  else {
    // if (!prevRightCursor || Math.sqrt((newCursor[1] - prevRightCursor[1])**2 + (newCursor[0] - prevRightCursor[0])**2) > 50){
    //   prevRightCursor = newCursor;
    //   return newCursor;
    // }
    // else{
    //   return prevRightCursor;
    // }
    const cursorDiffTiming = animationStep - (prevRightCursorTime || animationStep)
    prevRightCursorTime = animationStep;
    if (!prevRightCursor || cursorDiffTiming <= 0) {
      return newCursor;
    }
    const diffY = newCursor[1] - prevRightCursor[1];
    const diffX = newCursor[0] - prevRightCursor[0];
    const cursorSpeed = Math.sqrt((diffY) ** 2 + (diffX) ** 2) / cursorDiffTiming;
    const cursorDiffAmount = Math.min(1, cursorSpeed / 500);
    return [newCursor[0] + diffX * cursorDiffAmount, newCursor[1] + diffY * cursorDiffAmount];
  }
}


async function predictWebcam(animationStep) {
  // WARNING: EXPECT EXTREMELY SLOW PERFORMANCE ON FIREFOX
  let cursors = /** @type {Cursor[]} */ (new Array());
  const startTimeMs = performance.now();

  if (Game.activeScreens[0]){
    cursorSize = Game.activeScreens[0].screenState.S(50);
  }

  const results = poseModel === 'blazepose' ? (await poseLandmarker.estimatePoses(video, {maxPoses: 1, flipHorizontal: true}, startTimeMs))[0] : (await poseLandmarker.estimatePoses(video, undefined, startTimeMs))[0];
  const landmarks = results ? results.keypoints : undefined;
  canvasCtx.save();
  canvasCtx.clearRect(0, 0, canvasElement.width, canvasElement.height);
  if (landmarks) {
    document.getElementById("cursor-msg").classList.remove('is-active');

    if (poseModel === 'movenet'){
      if (landmarks[9]) {
        // 1.309 because golden ratio = 1.618, thus (1.618-1)/2 + 1 = 1.309
        // (distance from elbow to wrist)*1.309 = distance from elbow to center of palm 
        const left_cursor = smoothCursor(landmarks[7] ? extendLine(...getCorodinatesForMovenet(landmarks, 9), ...getCorodinatesForMovenet(landmarks, 7), 1.309) : getCorodinatesForMovenet(landmarks, 9), animationStep, true);
        // canvasCtx.beginPath();
        // canvasCtx.arc(...left_cursor, 50, 0,2*Math.PI);
        // canvasCtx.fillStyle = "red"
        // canvasCtx.fill();
        cursors.push(new Cursor(...left_cursor, "left", 50));
      }
      else {
        [prevLeftCursor, prevLeftCursorTime] = [undefined, undefined];
        cursors.push(new Cursor(0, 0, "left", 0));
      }
      
      if (landmarks[10]) {
        const right_cursor = smoothCursor(landmarks[8] ? extendLine(...getCorodinatesForMovenet(landmarks, 10), ...getCorodinatesForMovenet(landmarks, 8), 1.309) : getCorodinatesForMovenet(landmarks, 10), animationStep, false);
        // canvasCtx.beginPath();
        // canvasCtx.arc(...right_cursor, 50, 0,2*Math.PI);
        // canvasCtx.fillStyle = "blue"
        // canvasCtx.fill()
        cursors.push(new Cursor(...right_cursor, "right", 50))
      }
      else {
        [prevRightCursor, prevRightCursorTime] = [undefined, undefined];
        cursors.push(new Cursor(0, 0, "right", 0))
      }
    }
    else if (poseModel === 'blazepose'){
      const left_coordinates = getCorodinatesForBlazepose(landmarks, 15, 17, 19);
      if (left_coordinates) {
        cursors.push(new Cursor(...left_coordinates, "left", 50));
      }
      else {
        cursors.push(new Cursor(0, 0, "left", 0));
      }
      
      const right_coordinates = getCorodinatesForBlazepose(landmarks, 16, 18, 20);
      if (right_coordinates) {
        cursors.push(new Cursor(...right_coordinates, "right", 50))
      }
      else {
        cursors.push(new Cursor(0, 0, "right", 0))
      }
    }
    // document.getElementById("left-hand-cursor").style.setProperty("--cursor-x", landmarks[9].x);
    // document.getElementById("left-hand-cursor").style.setProperty("--cursor-y", landmarks[9].y);
    // document.getElementById("right-hand-cursor").style.setProperty("--cursor-x", landmarks[10].x);
    // document.getElementById("right-hand-cursor").style.setProperty("--cursor-y", landmarks[10].y);
  }
  else {
    cursors = [new Cursor(0, 0, "left", 0), new Cursor(0, 0, "right", 0)]
    // document.getElementById("cursor-msg").innerHTML = "Please Stand in the view of the camera!"
    document.getElementById("cursor-msg").classList.add('is-active');
    // document.getElementById("left-hand-cursor").classList.add('is-gone');
    // document.getElementById("right-hand-cursor").classList.add('is-gone');
  }

  if (animationStep) {
    Game.renderScreen(animationStep, cursors, results && results.segmentation ? new RenderableSegmentationMask(await results.segmentation.mask.toImageData(), videoScalling) : undefined);
  }

  canvasCtx.font = '48px Yusei Magic';
  canvasCtx.textAlign = 'left';
  canvasCtx.textBaseline = 'bottom';
  canvasCtx.globalAlpha = 1;
  
  if (showFPS && prevTimeMs) {
    const infer_speed = startTimeMs - prevTimeMs;
    if (infer_speed >= 60) {// About 16 FPS and below
      canvasCtx.fillStyle = "red";
    }
    else if (infer_speed >= 35) {// About 28 FPS and Below  
      canvasCtx.fillStyle = "yellow";
    }
    else {// More than or equal to 28 FPS
      canvasCtx.fillStyle = "limegreen";
    }
    canvasCtx.fillText(`FPS: ${Math.floor(1000/infer_speed)}`, 0, window.innerHeight + (canvasElement.height - window.innerHeight) / 2);
  }

  canvasCtx.globalAlpha = 0.5;
  canvasCtx.fillStyle = "#EB5E55"
  
  if (cursors[0].radius > 0) {
    canvasCtx.beginPath();
    canvasCtx.arc(cursors[0].x, cursors[0].y, cursorSize, 0, 2 * Math.PI);
    canvasCtx.fill();
  }
  if (cursors[1].radius > 0) {
    canvasCtx.beginPath();
    canvasCtx.arc(cursors[1].x, cursors[1].y, cursorSize, 0, 2 * Math.PI);
    canvasCtx.fill();
  }
  
  canvasCtx.globalAlpha = 1;
  canvasCtx.restore();
  if (activePageEventLoop) {
    activePageEventLoop(landmarks);
  }

  prevTimeMs = startTimeMs;
  // Call this function again to keep predicting when the browser is ready.
  if (predictionActive) {
    window.requestAnimationFrame(predictWebcam);
  }
}




$(() => {
  $('#FPSCheckbox').prop('checked', showFPS);
  $('#poseModelSelect').val(`${poseModel}-${poseModelMode}`);
  updateLang();
  $('html').addClass('load-finish');
  initUtils()
  page1Init()
});
